import React from 'react';
import { Menu, MenuItem, IconButton, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../../context/AuthContext';

function MobileMenu({
    anchorEl,
    handleMenuOpen,
    handleMobileMenuClose,
    handleUserMenuOpen,
    handleNotificationMenuOpen,
}) {
    const { notificationsCount } = useAuth();

    return (
        <>
            <Menu
                anchorEl={anchorEl}
                open={handleMenuOpen}
                onClose={handleMobileMenuClose}
                keepMounted
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={handleNotificationMenuOpen}>
                    <IconButton size="small" color="inherit">
                        <Badge badgeContent={notificationsCount} color="secondary">
                            <NotificationsIcon />
                        </Badge>
                    </IconButton>
                    <p>Notifications</p>
                </MenuItem>
                <MenuItem onClick={handleUserMenuOpen}>
                    <IconButton size="small" color="inherit">
                        <AccountCircleIcon />
                    </IconButton>
                    <p>Profile</p>
                </MenuItem>
            </Menu>
        </>
    );
}

export default MobileMenu;
